import axios from "axios";

// Cliente HTTP: todas las llamadas privadas llevan la clave (= ruta secreta) en X-Access-Key
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const setAccessKey = (key) => {
  api.defaults.headers.common["X-Access-Key"] = key;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Ocurrió un error, intente de nuevo";
};

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
